import { ArrowUpward, ArrowDownward } from '@mui/icons-material';
import { sortOrder } from '~/types/enum';
import {
  cell,
  SORT_ICON_STYLE,
} from '~/components/Admin/ResourceTable/ResourceTable.style';
import { TSort } from '~/types/common.type';
import { TSearchCondition } from '~/store/resource/resource.type';

type TProps = {
  data: { title: string; property: string };
  sort: TSort<string>;
  handleSort: (property: string) => void;
};

const NOT_SORT_LIST = ['edit'];

export const TableHeaderCell = ({ data, sort, handleSort }: TProps) => {
  if (data.property === 'checkbox') {
    return null;
  }
  return (
    <cell.Container>
      <cell.HeaderContent
        onClick={() => handleSort(data.property as keyof TSearchCondition)}
      >
        {data.title}
        {!NOT_SORT_LIST.includes(data.property) && (
          <>
            {sort.property === data.property &&
              sort.order === sortOrder.ASC && (
                <ArrowUpward
                  sx={{
                    ...SORT_ICON_STYLE(true),
                  }}
                />
              )}
            {sort.property === data.property &&
              sort.order === sortOrder.DESC && (
                <ArrowDownward
                  sx={{
                    ...SORT_ICON_STYLE(true),
                  }}
                />
              )}
            {sort.property !== data.property && (
              <ArrowUpward
                sx={{
                  ...SORT_ICON_STYLE(false),
                }}
              />
            )}
          </>
        )}
      </cell.HeaderContent>
    </cell.Container>
  );
};
